import React from 'react';
import { Box, TextField, Button, Grid, Alert } from '@mui/material';

const ChangePassword = () => {
  return (
    <Box component="form" noValidate sx={{ mt: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            name="currentPassword"
            label="Current Password"
            type="password"
            autoComplete="current-password"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            name="newPassword"
            label="New Password"
            type="password"
            autoComplete="new-password"
            helperText="Password must be at least 8 characters long and contain at least one number, one uppercase letter, and one special character."
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            name="confirmPassword"
            label="Confirm New Password"
            type="password"
            autoComplete="new-password"
          />
        </Grid>
        <Grid item xs={12}>
          <Alert severity="info" sx={{ mb: 2 }}>
            Make sure your new password is strong and different from your previous passwords.
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3 }}
          >
            Change Password
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ChangePassword; 